import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApiV2 } from "@/services/apiAuth";
import { useAuthContext } from "../contexts/AuthContext";

const PocheteLogo = () => (
  <img
    src="/logos/pochete.svg"
    alt="Pochete.App"
    className="w-16 h-16"
    draggable={false}
  />
);

const PocheteLogoText = () => (
  <img
    src="/logos/pochete-text.svg"
    alt="Pochete.App"
    className="h-10 mx-auto"
    draggable={false}
  />
);

const LoginScreen: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setIsAuthenticated } = useAuthContext();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email && password) {
      const response = await authApiV2.login(email, password);
      if (response.status === 200 && response.body.token) {
        setIsAuthenticated(true);
        navigate("/main", { replace: true });
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gradient-to-br from-blue-400 to-blue-600">
      <div className="w-full max-w-md p-8 bg-white rounded-3xl shadow-2xl border border-white/20">
        <div className="flex flex-col items-center justify-center gap-3 mb-8">
          <PocheteLogo />
          <PocheteLogoText />
        </div>

        <div className="text-center mb-10">
          <div className="mb-2"></div>
          <p className="text-zinc-500 font-medium italic">
            Sua grana guardada com inteligência
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-xs font-bold text-zinc-400 uppercase tracking-widest mb-2 ml-1">
              E-mail
            </label>
            <input
              type="email"
              required
              className="w-full px-4 py-4 rounded-xl border border-zinc-100 bg-zinc-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#3f83f8] transition-all placeholder:text-zinc-300"
              placeholder="exemplo@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-zinc-400 uppercase tracking-widest mb-2 ml-1">
              Senha
            </label>
            <input
              type="password"
              required
              className="w-full px-4 py-4 rounded-xl border border-zinc-100 bg-zinc-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#3f83f8] transition-all placeholder:text-zinc-300"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="w-full py-4 bg-[#3f83f8] hover:bg-blue-600 text-white font-bold rounded-xl shadow-lg shadow-blue-200 transition-all active:scale-[0.98] mt-2"
          >
            Entrar no App
          </button>
        </form>

        <div className="mt-10 text-center border-t border-zinc-50 pt-6">
          <p className="text-sm text-zinc-400 font-medium">
            Pronto para organizar seu bolso?
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
